import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import Constants from "../business/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";
import UrlHelper from "../helpers/url.helper";
import moment from "moment";
import Pristine from "pristinejs/dist/pristine";

class CompletaDatiCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);

		this.userPrivacyProfiling = false;

		// regex
		this.addressValidationRegexp = /^[a-zA-Z0-9àáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð ,.'-/°]{2,120}$/;

		this.productNumber = this.element.dataset["productNumber"] || 1;

		this.files = [];
		this.promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});
		this.pristine;
		this.init();
	}
	init() {
		this.loadChildComponents(this);
		this.startLoader();

		let form = document.getElementById("template-form");

		let formConfig = {
			// class of the parent element where the error/success class is added
			classTo: 'col-form',
			errorClass: 'error',
			successClass: 'has-success',
			// class of the parent element where error text element is appended
			errorTextParent: 'col-form',
			// type of element to create for the error text
			errorTextTag: 'span',
			// class of the error text element
			errorTextClass: 'error-field'
		};



		// termine ultimo per richiedere il premio
		/*
		this.promoApi.status().then((resp) => {
			let response = resp.body.response.data;


			if(moment(response.promo.dates.prize_request_end.raw).diff(moment()) < 0){
				let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
										<div class="feedback__modal__wrap">
											<div class="feedback__modal__content">
												<h2 class="h3">${response.promo.prize_request_ended_description}</h2>
												<a class="button" href="/promozioni/promocolazione2022/area-personale">Torna all'area personale</a>
											</div>
										</div>
									</div>`;
				$(this.element).append(tmplModalGeneric);
				this.loadChildComponents(this);
				this.removeLoader();
				return;
			}
		});
		*/


		let play_mode = UrlHelper.getUrlParam('pm');
		let play_token = UrlHelper.getUrlParam('pt');


		if(this.productNumber === 1){
			$('#product2').parents(".pp-dropdown-cnt").hide();
			$('#product2').remove();
		}

		if ( play_mode == "1"){
			$('.playmode_1').remove();
		}


		this.trimRequired();

		// init form validator
		this.pristine = new Pristine(form, formConfig);
		this.address = document.getElementById('indirizzo');

		if(play_mode != "1"){
			// add validator for some fields
			this.validatorProduct('product');
			this.validatorProduct('product2');
			this.validatorReceiptPhoto();
		}

		this.regexAddress();


		GigyaManager.getLoggedUserCached().then(async (u) => {
			this.userPrivacyProfiling = u.preferences.privacy_profiling.isConsentGranted;
			this.promoApi.areaPersonale().then(async resp => {
				const win = resp.body.response.data.receipts.filter(c =>  c.status === "WIN" && c.playdata.play_token === play_token);

				if(win.length > 0) {
					if(play_mode == "3"){
						$('input[name="storeType"]').change(()=>{
							let val = $('input[name="storeType"]:checked').val();
							this.startLoader();
							this.promoApi.elencoStore(val != 'offline').then((result)=> {
								this.buildDropdownStore(result.body);
								this.removeLoader();
							});
						})

						let stores = await this.promoApi.elencoStore(false);
						this.buildDropdownStore(stores.body);

						this.productData = await this.promoApi.elencoProdotti();
						this.productData = this.productData.body;
						this.buildDropdownProduct(this.productData);
					}

					await this.buildDropdownRegioni();
					await this.buildDropdownProvince();
					await this.buildDropdownProvincePdv();

					window.gigyaIntegration.autocompleteForm('#template-form', () => {
						this.buildDropdownCities();
					});

					$('#regione-pdv').change(()=>{
						this.startLoader();
						this.buildDropdownProvincePdv($('#regione-pdv').val());
						this.removeLoader();
					});

					// event on change provincia
					$('#provincia').change(() => {
						this.startLoader();
						this.buildDropdownCities();
					});

					this.removeLoader();
				}else{
					let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                        <div class="feedback__modal__wrap">
                                                            <div class="feedback__modal__content">
                                                                <h2 class="h3">Ops, il premio non risulta associato al tuo account! </h2>
                                                                <p>Stai provando a richiedere un premio che non risulta appartenere al tuo account!</p>
                                                                <a class="button" href="/promozioni/promocolazione2022/area-personale">Torna all'area personale</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                `;
					$(this.element).append(tmplModalGeneric);
					this.loadChildComponents(this);
					this.removeLoader();
				}
			})
		}, () => {
			window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
		});

		//IMAGE VIEW
		$('#foto-scontrino').change(() => {
			var input =  $('#foto-scontrino')[0];
			let file = input.files[0];
			var maxSize = $(input).data('max-size');


			if (maxSize > file.size) {
				this.startLoader();

				this.promoApi.uploadFile(file, this.files.length == 0 ? 1 : 2).then((resp)=>{
					let data = resp.body;
					let filename_server = data.response.data.filename;
					let idx_file = filename_server.split(".")[0];
					var reader = new FileReader();
					reader.onload = function (e) {
						if (filename_server.match(/pdf$/)) {
							$('.file-list').append('<div class="row" id="'+idx_file+'"><div class="figure"><img' +
								' src="/fe-web/img/icons/avatar_placeholder.jpg"></div><div' +
								' class="file-name">' + file.name + '</div><div class="delete-file" component-click="removeFile(\''+idx_file+'\')"></div></div>');
						} else {
							$('.file-list').append('<div class="row" id="'+idx_file+'"><div class="figure"><img src="' + e.target.result + '"></div><div class="file-name">' + file.name + '</div><div class="delete-file" component-click="removeFile(\''+idx_file+'\')"></div></div>');
						}
					}
					reader.readAsDataURL(file);
					this.files.push(filename_server);
					if(this.files.length == 2){
						$('#foto-scontrino').prop("disabled", true);
						$('.carica-scontrino').addClass('disabled');
					}else{
						$('#foto-scontrino').prop("disabled", false);
						$('.carica-scontrino').removeClass('disabled');
					}
					$('#foto-scontrino').val('');

					// before delete all error messages
					$(".uploadFile .pristine-error").empty();

					// and then force validate receipt photo
					this.pristine.validate(document.getElementById('foto-scontrino'));

					this.removeLoader();
				}, () => {
					//TODO POPUP ERRORE
					$('#foto-scontrino').prop("disabled", false);
					$('.carica-scontrino').removeClass('disabled');
					$('#foto-scontrino').val('');
					this.removeLoader();
				})
			}else{
				$('#foto-scontrino').addClass('error');
				if($(".uploadFile .error-field").length){
					$(".uploadFile .error-field").append("<br>Il file caricato è troppo grande");
				}else {
					$(".uploadFile").append('<span class="pristine-error error-field">Il file caricato è troppo grande</span>');
				}
			}
		});
	}

	buildDropdownStore(stores){
		let options = '<option value="-" default="true">Scegli lo store</option>';

		let storeList = stores.response.data;
		for(var i = 0; i < storeList.length; i++){
			options += `<option value="${storeList[i].tag}">${storeList[i].description}</option>`
		}
		$('#market').html(options);
		if(storeList.length == 1){
			$('#market').val(storeList[0].tag);
			$('#market').hide();
			$('#market').next().hide();
		}else{
			$('#market').val("-");
		}
	}

	buildDropdownProduct(productData){
		let options = '';

		let productList = productData.response.data;
		for(var i = 0; i < productList.length; i++){
			options += `<option value="${productList[i].code}">${productList[i].description}</option>`
		}

		$('#product').html('<option value default="true"">Scegli il prodotto Numero1</option>'+options);
		$('#product2').html('<option value default="true">Scegli il prodotto Numero2</option>'+options);
		$('#product').val("");
		$('#product2').val("");
	}

	/**
     *
     * @returns {Promise<void>}
     */
	async buildDropdownRegioni(){
		let options = '<option value="" default="true">Scegli la regione</option>';

		let resp = await this.promoApi.elencoRegioni("");
		let regionList = resp.body.response.data;
		for(var i = 0; i < regionList.length; i++){
			options += `<option value="${regionList[i].id}" data-region-id="${regionList[i].id}">${regionList[i].description}</option>`
		}

		$('#regione-pdv').html(options);
		$('#regione-pdv').val("");
	}

	/**
     * Build dropdown of two fields (provincia-pdv, provincia)
     * @returns {Promise<void>}
     */
	async buildDropdownProvince(){
		let options = '<option value="" default="true">Scegli la provincia</option>';

		let resp = await this.promoApi.elencoProvince();
		let provinceList = resp.body.response.data;
		for(var i = 0; i < provinceList.length; i++){
			//options += `<option value="${provinceList[i].id}" data-province-short-desc="${provinceList[i].short_description}" data-region-id="${provinceList[i].region.id}">${provinceList[i].description}</option>`
			options += `<option value="${provinceList[i].short_description}" data-id-value="${provinceList[i].id}" data-province-short-desc="${provinceList[i].short_description}" data-region-id="${provinceList[i].region.id}">${provinceList[i].description}</option>`
		}



		// build field provincia
		$('#provincia').html(options);
		//$('#provincia').val("");
	}

	async buildDropdownProvincePdv(idRegion){
		let options = '<option value="" default="true">Scegli la provincia</option>';

		if(idRegion){
			let resp = await this.promoApi.elencoProvince(idRegion);
			let provinceList = resp.body.response.data;
			for(var i = 0; i < provinceList.length; i++){
				options += `<option value="${provinceList[i].id}" data-region-id="${provinceList[i].id}">${provinceList[i].description}</option>`
			}

			this.removeLoader();
		}



		$('#provincia-pdv').html(options);
		$('#provincia-pdv').val("");
	}

	/**
     * Build Dropdown city by id
     * @returns {Promise<void>}
     */
	async buildDropdownCities(){
		let options = '<option value="" default="true">Scegli la città</option>';
		let dataIdProvince = $('#provincia option:selected').attr('data-id-value');
		if(dataIdProvince) {
			let resp = await this.promoApi.elencoCitta(dataIdProvince);
			let provinceList = resp.body.response.data;
			for(var i = 0; i < provinceList.length; i++){
				options += `<option value="${provinceList[i].id}" >${provinceList[i].description}</option>`
			}

			$('#citta').html(options);
			$('#citta').val("");
		}
		this.removeLoader();
	}

	/**
	 * Trim all required fields
	 */
	trimRequired(){
		Pristine.addValidator('required', (value) => {
			return ( value.trim() !== '' );
		}, "", 5, false);
	}

	/**
	 * Check value product
	 * @param {String} idField
	 * @return {Boolean}
	 */
	validatorProduct(idField){
		let id = document.getElementById(idField);
		this.pristine.addValidator(id, (value) => {
			let productArr = this.productData.response.data.map((o) => o.code);
			if (productArr.indexOf(value) >= 0){
				return true;
			}
			return false;
		}, "", 5, false);
	}

	/**
	 * Check media inserted
	 * @return {Boolean}
	 */
	validatorReceiptPhoto(){
		let id = document.getElementById('foto-scontrino');
		this.pristine.addValidator(id, () => {
			if(this.files.length > 0) {
				return true;
			}
			return false;
		}, "Devi caricare almeno una foto dello scontrino!", 2, false);
	}

	/**
	 * Regex address
	 */
	regexAddress(){
		this.pristine.addValidator(this.address, (value) => {
			// here `this` refers to the respective input element
			if (!this.addressValidationRegexp.test(value)){
				return false;
			}
			return true;
		}, "Il campo contiene caratteri non consentiti o supera la lunghezza massima di 120 caratteri", 2, false);
	}

	/**
	 * Submit form, start loading and init validate
	 */
	submit(){
		this.startLoader();
		this.validateForm();
	}


	sendForm(){
		let inputs = $('.col-form > input, .col-form #citta, .col-form #provincia');
		let form = {
			basedata: {
				play_token: UrlHelper.getUrlParam('pt')
			},
			customdata: {}
		};
		for(let i = 0; i < inputs.length; i++){
			let input = $(inputs[i]);
			if(input.attr("id") !== "foto-scontrino" && input.attr("id") !== "prefix" && input.attr("id") !== "provincia"){
				form.basedata[input.attr('name')] = input.val();
			}

			if(input.attr("id") === "provincia"){
				form.basedata[input.attr('name')] = $("#provincia option:selected").data('id-value');
			}
		}

		form.basedata["user_phone"] = "39" + form.basedata["user_phone"];

		// RECEIPT IMAGE
		form.basedata.receipt_file_front = this.files[0];
		if(this.files.length > 1){
			form.basedata['receipt_file_back'] = this.files[1];
		}

		// PROFILING
		form.customdata['user_profiling'] = this.userPrivacyProfiling ? 1 : 0;


		if(UrlHelper.getUrlParam('pm') == "3"){
			form.customdata['products'] = [{code: $('#product').val(), quantity: 1}];
			form.customdata['store'] = $('#market').val();
			if(this.productNumber > 1){
				form.customdata['products'].push({code: $('#product2').val(), quantity: 1})
			}

			// add regionId, provinceId
			form.customdata['regionid'] = $('#regione-pdv').val();
			form.customdata['provinceid'] = $('#provincia-pdv').val();
		}


		this.promoApi.richiediPremio(form).then(()=>{
			window.location.href = "/promozioni/promocolazione2022/thank-you";
		}, (err)=>{
			this.removeLoader();
			let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>${err.body.status.errors.data.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
			$(this.element).append(tmplModalGeneric);
			this.loadChildComponents(this);
		});
	}

	removeFile(idx){
		$('#'+idx).remove();
		for(let i = 0; i < this.files.length; i++ ){
			if(this.files[i].indexOf(idx) != -1){
				this.files.splice(i, 1);
			}
		}
		if(this.files.length == 2){
			$('#foto-scontrino').prop("disabled", true);
			$('.carica-scontrino').addClass('disabled');
		}else{
			$('#foto-scontrino').prop("disabled", false);
			$('.carica-scontrino').removeClass('disabled');
		}
	}

	removeLoader(){
		$('.tool_loader').fadeOut(500).remove();
		$('body').removeClass('noScroll');
		$('#conferma').prop("disabled", false).removeClass('disabled');
	}

	startLoader(){
		$('.mb-promo').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
		$('body').addClass('noScroll');
		$('#conferma').prop("disabled", true).addClass('disabled');
	}

	/**
	 * Open modal
	 */
	showProgressiveProfiling(){
		$('.progressive-profiling-modal-cnt').show();
		$('body').addClass('noScroll');
	}

	/**
	 * Validate pristine form
	 * @return {boolean}
	 */
	validateForm(){
		let valid = this.pristine.validate();

		if(valid){
			$('.error-feedback').remove();
			$('input, select').removeClass('error');

			// show modal
			this.showProgressiveProfiling();
		} else {
			this.removeLoader();
			this.scrollToError();
			return false;
		}
	}


	/**
	 * Submit form by modal CTA
	 * @param {Boolean} toDoUpdate
	 */
	updateProfile(toDoUpdate){
		$('.progressive-profiling-modal-cnt').hide();
		if(toDoUpdate){
			try {
				window.gigyaIntegration.saveForm('#template-form', () => {
					// save city data
					let cityInfo = {
						profile: {
							city: $("#citta option:selected").text()
						}
					};
					GigyaManager.setAccountInfo(cityInfo);
					this.sendForm();
				});
			} catch (e) {
				console.log(e);
				this.removeLoader();
				let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>Errore durante l'aggiornamento dei campi del profilo.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
				$(this.element).append(tmplModalGeneric);
				this.loadChildComponents(this);
			}
		}else{
			this.sendForm()
		}
	}

	/**
	 * Scroll to error
	 */
	scrollToError(){
		$([document.documentElement, document.body]).animate({
			scrollTop: $(".error").offset().top - 25
		}, 1500);
	}
}

export default CompletaDatiCtrl;
